/**
 * Created by anthony on 7/7/14.
 */
var carouselModalCud = angular.module('carouselModalCud', ['classy']);
carouselModalCud.factory('carouselModalCud', function($timeout, StandardCudFactory, StandardModalCudFactory)
{
    var CarouselModalCudFactory = function(model, id, item, ctrl, dirtyVars, index, $modalInstance)
    {
        ctrl.$.index = index;
        ctrl.$.$modalInstance = $modalInstance;
        StandardCudFactory.apply(this, arguments)

    };

    CarouselModalCudFactory.prototype = new StandardCudFactory();
    CarouselModalCudFactory.prototype.parent = StandardCudFactory.prototype;
    CarouselModalCudFactory.prototype._removeIndex = function()
    {
        this.controller.$.items.splice(this.controller.$.index, 1);
        if (this.controller.$.items.length == 0)
            this.modalCud.closeModal(this.controller);
    }
    CarouselModalCudFactory.prototype.toggleEdit = function(index, saved)
    {
        if (index == -1)
        {
            this.model.revertCopy();
            this.controller.$.items = this.controller.model.get();
        }
        else
        {
            this.controller.$.items = this.controller.model.data;
            this.controller.$.item = this.controller.$.items[index];

        }
        this.controller.$.showEdit = !this.controller.$.showEdit;
        this.controller.$.index = index;
    }
    CarouselModalCudFactory.prototype.successSave = function(scope, instance, callback)
    {
        this.parent.successSave.apply(this, arguments);
        this.model.updateCopy();
        var parent = this;
        $timeout(function() {
            parent.toggleEdit(-1, true);
        }, 500);
    }
    CarouselModalCudFactory.prototype.successDelete = function(scope, instance)
    {
        this.parent.successDelete.apply(this, arguments);
        var parent = this;
        $timeout(function() {
            parent.controller.$.showEdit = !parent.controller.$.showEdit;
            parent._removeIndex();
            parent.controller.$.index = -1;
        }, 500);
    }
    CarouselModalCudFactory.prototype.add = function()
    {
        this.toggleEdit(this.controller.model.new());
    }
    return CarouselModalCudFactory;
});

carouselModalCud.service('CarouselModalCudService', function(CarouselModalCudFactory){
    var carouselModalCud = new CarouselModalCudFactory();
    return carouselModalCud;
});